import { useContext } from 'react';

import { DealPromptContext } from '../utils/context/DealPromptContext';

export function useDealPrompt() {
  const dealPromptContextValue = useContext(DealPromptContext);

  return dealPromptContextValue;
}
